export default 
{
	"progressbar-page-title": "Σελίδα",
	"name-suffix": "Επίθεμα",
	"fileupload-desc-progress-message": "Μεταφόρτωση {progress}",
	"required-if-greater-than-or-equal": "{property} είναι υποχρεωτικό όταν {compareSource} είναι μεγαλύτερο ή ίσο από {compareValue}.",
	"powered-by-cognito": "Με τη βοήθεια της Cognito Forms.",
	"form-name-default": "Χωρίς τίτλο",
	"field-choice-defaults": "Πρώτη Επιλογή|Δεύτερη Επιλογή|Τρίτη Επιλογή",
	"additional-fee-default-label": "Πρόσθετε Χρεώσεις",
	"authenticated-save-and-resume-email-dialog": "Στείλτε έναν σύνδεσμο μέσω email και επιστρέψτε στη φόρμα σας για να ολοκληρώσετε την υποβολή σας.",
	"string-length-between": "{property} πρέπει να έχει μεταξύ {min} και {max} χαρακτήρες.",
	"update-button-text": "Κάντε ενημερώσεις",
	"address-zip-code-invalid": "Ο Τ.Κ. πρέπει να είναι της μορφής #####-####.",
	"required-if-greater-than": "{property} είναι υποχρεωτικό όταν {compareSource} είναι μεγαλύτερο από {compareValue}.",
	"compare-before": "{property} πρέπει να είναι πριν από {compareSource}.",
	"compare-after": "{property} πρέπει να είναι μετά από {compareSource}.",
	"unsupported-browser-message": "Ωχ! Το πρόγραμμα περιήγησης που χρησιμοποιείτε δεν υποστηρίζεται. {a}Πατήστε εδώ{/a} για αναβάθμιση.",
	"shared-entry-email-subject": "Σύνδεσμος Διαμοιρασμού",
	"send-button-text": "Αποστολή",
	"venmo-help-text": "Συνδεθείτε στο Venmo για να συνεχίσετε με την πληρωμή.",
	"field-repeatingsection-item-label": "Αντικείμενο",
	"save-and-resume-email-not-sent-message": "Υπήρξε ένα πρόβλημα.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} πρέπει να είναι τουλάχιστον {min}.",
	"entry-notification-full-entry-detail-link": "Δείτε την πλήρη εγγραφή στο cognitoforms.com.",
	"element-label-website": "Ιστοσελίδα",
	"element-label-signature": "Υπογραφή",
	"paypal-help-text": "Συνδεθείτε στο PayPal για να συνεχίσετε με την πληρωμή.",
	"card-on-file-agreement-validation": "Πρέπει να συμφωνήσετε να αποθηκεύσετε την κάρτα σας για μελλοντικές συναλλαγές.",
	"marketing-button-4": "Φτιάξτε την δική σας φόρμα δωρεάν",
	"field-datepicker-now": "Τώρα",
	"save-and-resume-email-resume-button": "Συνεχίστε τώρα!",
	"field-datepicker-next-month": "Επόμενος Μήνας",
	"quantity-remaining-text": "παραμένων",
	"payment-declined": "Απόρριψη Πληρωμής",
	"required-if-before": "{property} είναι υποχρεωτικό όταν {compareSource} είναι πριν από {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} πρέπει να είναι μικρότερο από {compareSource}.",
	"entry-admin-link": "Σύνδεσμος Διαχειριστή",
	"required-many": "{0} είναι υποχρεωτικά.",
	"save-and-resume-multiple-days-expiration-email-message": "Χρησιμοποιήστε τον παρακάτω σύνδεσμο για να ολοκληρώσετε την υποβολή της φόρμας εντός των επόμενων {days} ημερών .",
	"string-length-at-least": "{property} πρέπει να έχει τουλάχιστον {min} χαρακτήρες.",
	"credit-card-number": "Αριθμός Πιστωτικής Κάρτας",
	"range-on-or-before": "{property} πρέπει να είναι επί ή πριν από {max}.",
	"required-one": "{0} είναι υποχρεωτικό.",
	"fileupload-max-file-count-exceeded-message": "Μόνο {maxFileCount} αρχεία μπορούν να μεταφορτωθούν.",
	"order-transaction-details-header": "Λεπτομέρειες Συναλλαγής",
	"field-spinner-increase": "Αυξάνουν",
	"payment-processing-fees": "Τέλη Επεξεργασίας",
	"payment": "Πληρωμή",
	"field-choice-other-fill-in": "Άλλο",
	"shared-entry-email-message": "Μια εγγραφή σας έχει διαμοιραστεί.",
	"shared-entry-workflow-link": "Δείτε τη φόρμα.",
	"required-if-exists": "{property} είναι υποχρεωτικό όταν {compareSource} είναι ορισμένο.",
	"concurrent-conflict-toast-message": "Η υποβολή σας απέτυχε επειδή οι πληροφορίες σε αυτήν τη φόρμα έχουν αλλάξει. Παρακαλούμε ελέγξτε και προσπαθήστε ξανά.",
	"secured-by-paypal": "εξασφαλισμένη από",
	"range-on-or-after": "{property} πρέπει να είναι επί ή μετά από {min}.",
	"payment-amount-due": "Ποσό",
	"required-name-first-and-last": "Το όνομα και το επώνυμο είναι υποχρεωτικό.",
	"required": "{property} είναι υποχρεωτικό.",
	"string-format-alphabetic": "{property} πρέπει να περιέχει μόνο γράμματα.",
	"quantity-limit": "{property} Υπερβαίνει την ποσότητα.",
	"field-spinner-decrease": "ελαττύ",
	"field-repeatingsection-add-link-text": "Προσθέστε",
	"fileupload-max-size-exceeded-message": "Μόνο μικρότερα αρχεία από {maxSize} MB μπορούν να μεταφορτωθούν.",
	"credit-card-expiration": "ΜΜ/ΕΕ",
	"field-signature-notcaptured": "Δεν καταγράφηκε",
	"field-ratingscale-satisfied-unsatisfied-label": "Ικανοποιημένος/Δυσαρεστημένος",
	"range-between": "{property} πρέπει να είναι μεταξύ {min} και {max}.",
	"field-ratingscale-agree-disagree-label": "Συμφωνώ/Διαφωνώ",
	"back-button-text": "Προηγούμενο",
	"address-country": "Χώρα",
	"order-not-found": "Δεν βρέθηκαν πληροφορίες της παραγγελίας.",
	"field-ratingscale-satisfied-unsatisfied-options": "Πολύ Δυσαρεστημένος|Δυσαρεστημένος|Ουδέτερος|Ικανοποιημένος|Πολύ Ικανοποιημένος",
	"entry-notification-entry-details-header": "Λεπτομέρειες Εγγραφής",
	"FALSE": "FALSE",
	"compare-greater-than-or-equal": "{property} πρέπει να είναι μεγαλύτερο ή ίσο από {compareSource}.",
	"receipt-notification-order-details-desc-header": "Λεπτομέρειες",
	"order-method-label": "Μέθοδος",
	"order-total-label": "Σύνολο",
	"invalid-shared-link": "Λάθος σύνδεσμος",
	"fileupload-zero-byte-file-message": "Μηδενικά αρχεία δεν μπορούν να μεταφορτωθούν.",
	"range-at-most": "{property} πρέπει να είναι το πολύ {max}.",
	"format-integer": "####",
	"order-date-label": "Ημερομηνία",
	"fileupload-dropzone-message": "ή σύρετε τα αρχεία εδώ.",
	"shared-entry-view-link": "Δείτε την κοινή εγγραφή.",
	"format-currency": "#.###,## €",
	"string-length-at-most": "{property} πρέπει να έχει το πολύ {max} χαρακτήρες.",
	"entry-confirmation-footer-tagline": "Δημιουργήστε την δική σας δυναμική φόρμα πληρωμής με",
	"submit-button-text": "Αποστολή",
	"marketing-msg": "Δημιουργήστε εύκολα δυναμικές φόρμες.",
	"required-if-on-or-after": "{property} είναι υποχρεωτικό όταν {compareSource} είναι επί ή μετά από {compareValue}.",
	"card-on-file-agreement": "Συμφωνώ να αποθηκεύσω την κάρτα μου για μελλοντικές συναλλαγές.",
	"signature-draw": "σχεδιάζω",
	"address-zip-code": "Τ.Κ.",
	"compare-on-or-after": "{property} πρέπει να είναι επί ή μετά από {compareSource}.",
	"required-if-less-than-or-equal": "{property} είναι υποχρεωτικό όταν {compareSource} είναι μικρότερο ή ίσο από {compareValue}.",
	"field-datepicker-next-year": "Επόμενο Έτος",
	"change-button": "αλλάζω",
	"fileupload-desc-size-in-bytes-message": "{size} bytes",
	"card-tab": "Κάρτα",
	"order-billing-info-header": "Πληροφορίες Χρέωσης",
	"entry-email-view-details-text": "Δείτε την πλήρη εγγραφή στο CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Χρησιμοποιήστε τον παρακάτω σύνδεσμο για να ολοκληρώσετε την υποβολή της φόρμας εντός της επόμενης ημέρας .",
	"credit-card-authentication-failed": "Η κάρτα απέτυχε στον έλεγχο ταυτότητας.",
	"compare-less-than-or-equal": "{property} πρέπει να είναι μικρότερο ή ίσο από {compareSource}.",
	"receipt-notification-order-details-balance-due": "Υπόλοιπο",
	"save-and-resume-multiple-days-expiration-message": "Αντιγράψτε ή στείλτε email το παρακάτω σύνδεσμο και επιστρέψτε εντός των επόμενων {days} ημερών στην φόρμα για να συνεχίσετε την υποβολή της.",
	"processing-fee-calculating-message": "Υπολογισμός",
	"receipt-notification-trx-details-method": "Μέθοδος",
	"field-choice-no-match": "Δεν βρέθηκαν αποτελέσματα",
	"fileupload-invalid-file-type-message": "Μόνο {allowedTypes} αρχεία μπορούν να μεταφορτωθούν.",
	"receipt-notification-trx-details-date": "Ημερομηνία",
	"credit-card-authorization": "Αδειοδότηση κάρτας",
	"address-line1": "Διεύθυνση 1",
	"required-if-not-exists": "{property} είναι υποχρεωτικό όταν {compareSource} δεν είναι ορισμένο.",
	"required-if-not-equal": "{property} είναι υποχρεωτικό όταν {compareSource} δεν είναι {compareValue}.",
	"marketing-button-2": "Φτιάξτε την δική σας φόρμα δωρεάν",
	"receipt-notification-billing-info-header": "Πληροφορίες Χρέωσης",
	"required-if-after": "{property} είναι υποχρεωτικό όταν {compareSource} είναι μετά από {compareValue}.",
	"element-label-name": "Όνομα",
	"required-if-equal": "{property} είναι υποχρεωτικό όταν {compareSource} είναι {compareValue}.",
	"connected-to-paypal": "Συνδεδεμένο στο PayPal.",
	"people-form-email-quantity-exceeded-message": "Η διεύθυνση email πρέπει να είναι μοναδική.",
	"receipt-notification-order-details-subtotal": "Μερικό Σύνολο",
	"shared-entry-edit-link": "Επεξεργαστείτε την κοινή εγγραφή.",
	"receipt-notification-trx-details-header": "Λεπτομέρειες Συναλλαγής",
	"address-city": "Πόλη",
	"receipt-notification-order-details-amount-paid": "Ποσό",
	"credit-card-invalid": "Η κάρτα δεν είναι έγκυρη.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Έχετε μια καινούργια υποβολή φόρμας.",
	"this-and-that": "{0} και {1}",
	"field-ratingscale-good-poor-label": "Καλό/Κακό",
	"network-unavailable-message": "Το δίκτυο δεν είναι διαθέσιμο. Δοκιμάστε ξανά αργότερα.",
	"dialog-close": "κλείνω",
	"string-format-alphanumeric": "{property} πρέπει να περιέχει μόνο γράμματα και αριθμούς.",
	"credit-card": "Πιστωτική Κάρτα",
	"remove-item": "Αφαιρέστε {item}",
	"receipt-notification-order-details-price-header": "Τιμή",
	"fileupload-upload-inprogress-message": "Η μεταφόρτωση του αρχείου είναι σε εξέλιξη.",
	"public-terms-of-service-link-text": "Όροι Χρήσης",
	"save-and-resume-email-subject": "Σύνδεσμος Αποθήκευσης \u0026 Συνέχισης",
	"field-repeatingsection-remove-link-text": "Αφαιρέστε",
	"field-ratingscale-na-label": "Δ/Υ",
	"add-item": "Προσθέστε {item}",
	"field-toggle-options": "Ναι/Όχι|True/False|Ανοιχτό/Κλειστό|Ενεργό/Ανενεργό|Αναγνωσμένο/Μη Αναγνωσμένο",
	"order-submit-timeout": "Η επεξεργασία της παραγγελίας διαρκεί πολύ. Παρακαλώ προσπαθήστε αργότερα.",
	"listlength-at-most": "Παρακαλώ να μην ορίσετε παραπάνω από {max} {property}.",
	"shared-entry-email-view-message": "Χρησιμοποιήστε τον παρακάτω σύνδεσμο για να δείτε την κοινή εγγραφή.",
	"order-number-label": "Αριθμός",
	"card-declined": "Η κάρτα απορρίφθηκε",
	"fileupload-default-upload-button-text": "Μεταφόρτωση",
	"name-prefix": "Τίτλος",
	"address-line2": "Διεύθυνση 2",
	"element-label-email": "Email",
	"field-ratingscale-good-poor-options": "Πολύ Κακό|Κακό|Μέτριο|Καλό|Πολύ Καλό",
	"next-button-text": "Επόμενο",
	"question": "Ερώτηση",
	"address-postalcode": "Ταχυδρομικός Κώδικας / Τ.Κ.",
	"format-with-description": "{property} πρέπει να διαμορφωθεί ως {description}.",
	"field-datepicker-prev-month": "Προηγούμενος Μήνας",
	"name": "Όνομα",
	"receipt-notification-order-details-total-footer": "Σύνολο",
	"confirmation-message": "Σας ευχαριστούμε για την συμπλήρωση της φόρμας. Η απάντηση σας έχει καταγραφεί.",
	"shared-entry-email-edit-message": "Χρησιμοποιήστε τον παρακάτω σύνδεσμο για να επεξεργαστείτε την κοινή εγγραφή.",
	"field-default-label": "Χωρίς τίτλο",
	"required-value": "{property} πρέπει να είναι {value}.",
	"name-middle": "Μεσαίο",
	"fileupload-failed-upload-message": "{fileName} απέτυχε να μεταφορτωθεί.",
	"shared-entry-email-button-label": "Προβολή Εγγραφής",
	"field-datepicker-year": "Έτος",
	"element-label-phone": "Τηλέφωνο",
	"TRUE": "TRUE",
	"listlength-between": "Παρακαλώ να ορίσετε μεταξύ {min} και {max} {property}.",
	"marketing-button-1": "Δοκιμάστε το τώρα!",
	"entry-submission-error-heading": "Σφάλμα επεξεργασίας εγγραφής",
	"order-not-found-message": "Δεν βρέθηκαν πληροφορίες της παραγγελίας.",
	"format-without-description": "{property} δεν είναι σωστά διαμορφωμένο.",
	"name-last": "Επώνυμο",
	"field-ratingscale-one-five-label": "Κλίμακα από 1 έως 5",
	"listlength-at-least": "Παρακαλώ να ορίσετε τουλάχιστον {min} {property}.",
	"united-states": "Ηνωμένες Πολιτείες",
	"field-signature-captured": "Καταγράφηκε",
	"compare-on-or-before": "{property} πρέπει να είναι επί ή πριν από {compareSource}.",
	"order-balance-due-label": "Υπόλοιπο",
	"required-if-less-than": "{property} είναι υποχρεωτικό όταν {compareSource} είναι μικρότερο από {compareValue}.",
	"credit-card-postalcode": "Ταχυδρομικός Κώδικας",
	"form-not-available-message": "Αυτή η φόρμα είναι προσωρινά μη διαθέσιμη.",
	"element-label-address": "Διεύθυνση",
	"receipt-notification-trx-details-number": "Αριθμός",
	"public-submission-warning": "Παρακαλώ μην υποβάλλετε κωδικούς πρόσβασης μέσω του Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Χρησιμοποιήστε τον παρακάτω σύνδεσμο για να ολοκληρώσετε την υποβολή της φόρμας.",
	"fileupload-excluded-file-type-message": "Αυτός ο τύπος των αρχείων δεν μπορεί να μεταφορτωθεί.",
	"payment-subtotal": "Μερικό Σύνολο",
	"collapse": "Συμπτύσσω",
	"save-button-text": "Αποθήκευση",
	"field-datepicker-prev-year": "Προηγούμενο Έτος",
	"signature-type": "οικογένεια",
	"order-amount-minimum": "Το Ποσό πρέπει να είναι τουλάχιστον 1,00 €.",
	"string-format-numeric": "{property} πρέπει να περιέχει μόνο αριθμούς.",
	"entry-confirmation-entry-details-header": "Λεπτομέρειες Εγγραφής",
	"connected-to-venmo": "Συνδεδεμένο με Venmo.",
	"format-percentage": "#,##%",
	"receipt-notification-header": "Απόδειξη Πληρωμής",
	"clear": "Καθαρισμός",
	"today": "Σήμερα",
	"required-name-last": "Το επώνυμο είναι υποχρεωτικό.",
	"marketing-button-3": "Δοκιμάστε το τώρα!",
	"expand": "Αναπτύσσω",
	"compare-greater-than": "{property} πρέπει να είναι μεγαλύτερο από {compareSource}.",
	"field-ratingscale-will-wont-label": "Θα/Δεν θα",
	"required-name-first": "Το όνομα είναι υποχρεωτικό.",
	"save-and-resume-one-day-expiration-message": "Αντιγράψτε ή στείλτε email το παρακάτω σύνδεσμο και επιστρέψτε εντός της επόμενης ημέρας στην φόρμα για να συνεχίσετε την υποβολή της.",
	"required-asterisk": "υποχρεωτικό",
	"credit-card-required": "Η πιστωτική κάρτα είναι απαραίτητη.",
	"address-state-province-region": "Πολιτεία / Επαρχία / Περιοχή",
	"save-and-resume-email-sent-message": "Το email έχει σταλεί.",
	"workflow-action": "Δράση",
	"field-ratingscale-will-wont-options": "Σίγουρα δεν|Πιθανόν δεν|Όχι σίγουρος|Πιθανόν θα|Σίγουρα θα",
	"save-and-resume-email-label": "Στείλτε email τον σύνδεσμο:",
	"field-ratingscale-agree-disagree-options": "Διαφωνώ Απολύτως|Διαφωνώ|Ουδέτερος|Συμφωνώ|Συμφωνώ Απολύτως",
	"order-exception-order-already-paid": "Αυτή η παραγγελία έχει ήδη πληρωθεί.",
	"fileupload-download-text": "Λήψη",
	"address-state": "Πολιτεία",
	"allowed-values": "{property} δεν είναι στην λίστα με τις επιτρεπόμενες τιμές.",
	"shared-entry-workflow-email-button-label": "Ανοίξτε τη Φόρμα",
	"compare-equal": "{property} πρέπει να είναι ίδιο με {compareSource}.",
	"field-datepicker-clear": "Καθαρισμός",
	"name-first": "Όνομα",
	"save-and-resume-message": "Η πρόοδος σας έχει αποθηκευτεί.",
	"save-and-resume-no-expiration-message": "Αντιγράψτε ή στείλτε email το παρακάτω σύνδεσμο και επιστρέψτε στην φόρμα για να συνεχίσετε την υποβολή της.",
	"entry-notification-view-details-text": "Δείτε Λεπτομέρειες",
	"order-exception-default-message": "Σφάλμα επεξεργασίας συναλλαγής.",
	"public-report-abuse-link-text": "Αναφορά Κατάχρησης",
	"order-amount-paid": "Ποσό",
	"element-label-default": "Χωρίς τίτλο",
	"countries": "Αγία Λουκία | Αγίας Έδρας | Άγιος Βικέντιος και Γρεναδίνες | Άγιος Χριστόφορος και Νέβις | Αγκόλα | Αζερμπαϊτζάν | Αίγυπτος | Αιθιοπία | Αϊτή | Ακτή Ελεφαντοστού | Αλβανία | Αλγερία | Αμερικανική Σαμόα | Ανατολή Τιμόρ (Τιμόρ-Λέστε) | Ανγκουίλα | Ανδόρα | Ανταρκτική | Αντίγκουα και Μπαρμπούντα | Αργεντινή | Αρμενία | Αρούμπα | Αυστραλία | Αυστρία | Αφγανιστάν | Βανουάτου | Βατικανό (Αγία Έδρα) | Βέλγιο | Βενεζουέλα | Βερμούδες | Βιετνάμ | Βολιβία | Βοσνία και Ερζεγοβίνη | Βουλγαρία | Βραζιλία | Γαλλία | Γαλλικά Νότια Εδάφη | Γαλλική Γουιάνα | Γαλλική Πολυνησία | Γερμανία | Γεωργία | Γιβραλτάρ | Γκάμπια | Γκαμπόν | Γκάνα | Γκουάμ | Γουαδελούπη | Γουατεμάλα | Γουιάνα | Γουινέα | Γουινέα-Μπισσάου | Γρενάδα | Γροιλανδία | Δανία | Δομινικανή Δημοκρατία | Δυτική Σαχάρα | Εκουαδόρ | Ελ Σαλβαδόρ | Ελβετία | Ελλάδα | Ερυθραία | Εσθονία | Ζάμπια | Ζιμπάμπουε | Ηνωμένα Αραβικά Εμιράτα | Ηνωμένες Πολιτείες | Ηνωμένο Βασίλειο | Θιβέτ | Ιαπωνία | Ινδία | Ινδονησία | Ιορδανία | Ιράκ | Ιράν (Ισλαμική Δημοκρατία) | Ιρλανδία | Ισημερινή Γουινέα | Ισλανδία | Ισπανία | Ισραήλ | Ιταλία | Καζακστάν | Καμερούν | Καμπότζη | Καναδάς | Κατάρ | Κάτω Χώρες | Κεντροαφρικανική Δημοκρατία | Κένυα | Κίνα | Κιργιστάν | Κιριμπάτι | Νησιά Κόκος | Κολομβία | Κομόρες | Κονγκό, Δημοκρατία της (Μπραζαβίλ) | Κορέα, Δημοκρατία της (Νότια Κορέα) | Κορέα, Λαϊκή Δημοκρατία της (Βόρεια Κορέα) | Κόσοβο | Κόστα Ρίκα | Κούβα | Κουβέιτ | Κροατία | Κύπρος | Λαϊκή Δημοκρατία του Κονγκό (Κινσάσα) | Λάος, Λαϊκή Δημοκρατία | Λεσόθο | Λετονία | Λίβανος | Λιβερία | Λιβύη | Λιθουανία | Λιχτενστάιν | Λουξεμβούργο | Μαγιότ | Μαδαγασκάρη | Μακάο | Μαλαισία | Μαλάουι | Μαλδίβες | Μαλί | Μάλτα | Μαρόκο | Μαρτινίκα | Μαυρίκιος | Μαυριτανία | Μαυροβούνιο | Μεγάλη Βρετανία | Μεξικό | Μιανμάρ, Βιρμανία | Μικρονησία, Ομόσπονδες Πολιτείες της Μικρονησίας | Μογγολία | Μοζαμβίκη | Μολδαβία, Δημοκρατία της Μολδαβίας | Μονακό | Μοντσεράτ | Μπανγκλαντές | Μπαρμπάντος | Μπαχάμες | Μπαχρέιν | Μπελίζε | Μπενίν | Μποτσουάνα | Μπουρκίνα Φάσο | Μπουρούντι | Μπουτάν | Μπρουνέι Νταρουσαλάμ | Ναμίμπια | Ναουρού | Νέα Ζηλανδία | Νέα Καληδονία | Νεπάλ | Νησιά Βόρειες Μαριάννες | Νησιά Καϋμάν | Νησιά Μάρσαλ | Νησιά Σολομώντα | Νησιά Φερόε | Νησιά Φώκλαντ | Νήσοι Κουκ | Νήσοι Τερκς και Κάικος | Νήσος Μαν | Νήσος των Χριστουγέννων | Νίγηρας | Νιγηρία | Νικαράγουα | Νιούε | Νορβηγία | Νότια Αφρική | Νότιο Σουδάν | Ντομίνικα | Ολλανδικές Αντίλλες | Ομάν | Ονδούρα | Ουγγαρία | Ουγκάντα | Ουζμπεκιστάν | Ουκρανία | Ουόλις και Φουτούνα | Ουρουγουάη | Πακιστάν | Παλαιστινιακές περιοχές | Παλάου | Παναμάς | Παπούα Νέα Γουινέα | Παραγουάη | Παρθένα νησιά (Βρετανικά) | Παρθένοι Νήσοι (ΗΠΑ) | Περού | Πιτκαίρν | Πολωνία | Πορτογαλία | Πουέρτο Ρίκο | Πράσινο Ακρωτήριο | Δημοκρατία της Βόρειας Μακεδονίας | Ρεουνιόν | Ρουάντα | Ρουμανία | Ρωσία | Σαμόα | Σαν Μαρίνο | Σάο Τομέ και Πρίνσιπε | Σαουδική Αραβία | Σενεγάλη | Σερβία | Σεϋχέλλες | Σιγκαπούρη | Σιέρρα Λεόνε | Σλοβακία (Δημοκρατία της Σλοβακίας) | Σλοβενία | Σομαλία | Σουαζιλάνδη | Σουδάν | Σουηδία | Σουρινάμ | Σρι Λάνκα | Συρία, Αραβική Δημοκρατία της Συρίας | Ταϊβάν (Δημοκρατία της Κίνας) | Ταϊλάνδη | Τανζανία | Τατζικιστάν | Τζαμάικα | Τζιμπουτί | Τιμόρ-Λέστε (Ανατολικό Τιμόρ) | Τόγκο | Τοκελάου | Τόνγκα | Τουβαλού | Τουρκία | Τουρκμενιστάν | Τρινιντάντ και Τομπάγκο | Τσαντ | Τσεχία | Τυνησία | Υεμένη | Φιλιππίνες | Φινλανδία | Φίτζι | Χιλή | Χονγκ Κονγκ",
	"name-middleinitial": "Μεσσαίο Αρχικό",
	"order-exception-empty-order": "Η παραγγελία πρέπει να περιέχει τουλάχιστον ένα αντικείμενο.",
	"compare-not-equal": "{property} πρέπει να είναι διαφορετικό από {compareSource}.",
	"entry-notification-footer": "Λαμβάνετε αυτό το email επειδή έχετε επιλέξει να λαμβάνετε τις ειδοποιήσεις της φόρμας στο Forms. ",
	"save-and-resume-copy-link-label": "Αντιγράψτε τον σύνδεσμο της φόρμας:",
	"entry-confirmation-footer": "Λαμβάνετε αυτό το email επειδή έχετε ολοκληρώσει μια συναλλαγή με [Name].",
	"required-if-on-or-before": "{property} είναι υποχρεωτικό όταν {compareSource} είναι επί ή πριν από {compareValue}.",
	"string-format": "{property} πρέπει να διαμορφωθεί ως {formatDescription}.",
	"switch-to-drawing-mode": "Μετάβαση σε λειτουργία σχεδίασης από λειτουργία πληκτρολόγησης.",
	"switch-to-typing-mode": "Μετάβαση σε λειτουργία πληκτρολόγησης από λειτουργία σχεδίασης."
};
